export const DEFAULT_ACTION = 'app/TopUpPage/DEFAULT_ACTION';
